<app-go-navigation>
    <div class="w-full justify-center min-h-screen overflow-hidden">
        <h1>Help</h1>

        <h2>What would you like to do?</h2>

        <h3>
            I see the three options available for Cevo Go, but what if I have
            other requirements?
        </h3>

        <p>
            Visit
            <a href="{{ externalLinks.cevoOnlineUrl }}">Cevo online</a>
            for all your other frequency coordination needs, or contact an EWA
            Spectrum Advisor at
            <a href="tel:{{ phoneNumber }}">{{ phoneNumber }}</a> or
            <a href="mailto:{{ email }}">{{ email }}</a
            >.
        </p>

        <h3>
            To use Cevo Go, do I have to log in or have a Cevo account or be a
            customer of EWA?
        </h3>

        <p>
            You do not need an account, or to login, but you will need to
            provide an email address so we can provide you results of your
            frequency search. You may create a Cevo account at no cost in the
            future, particularly to view the status of your applications in
            progress or completed.
        </p>

        <h2>Login</h2>

        <h3>
            To use Cevo Go, do I have to log in or have a Cevo account or be a
            customer of EWA?
        </h3>

        <p>
            You do not need an account, or to login, but you will need to
            provide an email address so we can provide you results of your
            frequency search. You may create a Cevo account at no cost in the
            future, particularly to view the status of your applications in
            progress or completed.
        </p>

        <h3>Why would I want to login to Cevo Go?</h3>

        <p>
            Registered users, whether members or non-members of EWA, have ready
            access to a dashboard online (web access required) of all
            applications underway or submitted to EWA, plus, those being
            finalized by EWA and transmitted to the FCC. All billing history is
            available as well on your Cevo Dashboard.
        </p>

        <h2>How do we contact you?</h2>

        <h3>To use Cevo Go, do I need to provide an email address to EWA?</h3>

        <p>
            You may login with an existing Cevo account, but if you wish to use
            Cevo Go without logging in, all we need is an email address (no
            password required), so EWA can transmit Cevo Go frequency search
            results to you. You then decide if you wish to create an account to
            take advantage of all the complimentary features of Cevo, including
            a Dashboard to view all your applications in progress and completed.
        </p>

        <h2>Confirm your email</h2>

        <h3>What do I do with an Access Code?</h3>

        <p>
            For Cevo Go to verify a supplied email address, cut and paste (or
            remember and enter) the received Access Code from your email
            program. Once verified, you'll be taken to the Cevo Go screen for
            entering your system technical data.
        </p>

        <h2>Input Technical Data</h2>

        <h3>
            What if I want to apply for a new license or modify one for which
            the parameters are not listed in Cevo Go, for example I'd like more
            than 5 frequencies or I have an emissions designator not listed, or
            I have an 800/900 MHz license?
        </h3>

        <p>
            Visit
            <a href="{{ externalLinks.cevoOnlineUrl }}">Cevo online</a>, which
            can handle all your frequency coordination requirements, or contact
            <a href="tel:{{ phoneNumber }}">{{ phoneNumber }}</a> or
            <a href="mailto:{{ email }}">{{ email }}</a>
        </p>

        <h3>
            I don't have latitude/longitude coordinates. Is there another way I
            can provide you my system location?
        </h3>

        <p>
            Select the "Coordinates - Other options" link, which allows you to
            (a) select your current location, (b) drop a pin on any location, or
            (c) enter a full address. Press "Use This Location" when ready to
            transfer into Cevo Go the lat/long of your selected location.
        </p>

        <h3>
            What should I do if Cevo Go does not recognize my ASR for
            latitude/longitude coordinates?
        </h3>

        <p>
            If you do not have the specific lat/long data to key in, select
            "Coordinates - Other options."
        </p>

        <h2>Other coordinate options</h2>

        <h3>
            I don't have latitude/longitude coordinates. Is there another way I
            can provide my system location?
        </h3>

        <p>
            Select the "Coordinates - Other options" link, which allows you to
            (a) select your current location, (b) drop a pin on any location, or
            (c) enter a full address. Press "Use This Location" when ready to
            transfer into Cevo Go the lat/long of your selected location.
        </p>

        <h2>Confirm your request</h2>

        <h3>What if I see a mistake in the system information I entered?</h3>

        <p>
            Click the "Back" button to re-enter any information. When satisfied,
            click "Next" to proceed to the "Confirm your request" screen.
        </p>

        <h2>Your search is processing</h2>

        <h3>
            The frequency search seems to be taking a long time. What can I do?
        </h3>

        <p>
            Depending on the location of your search, and particularly in major
            metropolitan or high population areas, results can take an hour or
            longer. You may use your mobile device for any other task while your
            search is processing, and you will be notified by email when your
            results are ready.
        </p>

        <h2>Results Ready</h2>

        <h3>
            I received an email that my results are ready, and when I returned
            to the Cevo Go mobile app, I see actual frequencies. Can I use these
            right away?
        </h3>

        <p>
            Cevo Go results are certified compliant with FCC Rules, but the
            frequency coordination process is not complete. If you are satisfied
            with the results, click "Confirm Order" so that EWA can finalize
            your application and transmit it to the FCC. You will be contacted
            by EWA prior to finalization.
        </p>

        <h3>
            I see a countdown clock for when my Cevo Go results will expire. Why
            do they expire and what can I do to extend the expiration period?
        </h3>

        <p>
            Although frequencies certified by EWA are available at the moment,
            they have not officially cleared the frequency coordination process
            until you confirm the request. They are therefore subject to claim
            by other applicants. A limited review window is necessary to ensure
            the frequencies are either officially coordinated for your
            application or they are released for others.
        </p>

        <h2>Payment method</h2>

        <h3>
            How can my company pay by invoice from EWA instead of credit card?
        </h3>

        <p>
            Please complete a
            <a href="{{ externalLinks.resourcesUrl }}">credit application</a>.
            EWA will contact you as soon as possible. It is recommended in the
            interim you proceed in Cevo Go with credit card payment.
        </p>

        <h2>Thank you for using EWA!</h2>

        <h3>
            I did not write down the information about my application in Cevo
            Go. How do I find that?
        </h3>

        <p>
            You will receive emails from EWA about your Cevo Go application,
            summarizing each step of the way, and all orders confirmed can also
            be tracked in your Cevo Dashboard. Contact EWA for assistance,
            <a href="tel:{{ phoneNumber }}">{{ phoneNumber }}</a> or
            <a href="mailto:{{ email }}">{{ email }}</a
            >.
        </p>
    </div>
</app-go-navigation>
